import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { TextInputBase, } from "./TextInputBase";
import { useDefaultProps } from "../providers/utils/defaultProps";
export const textFieldClasses = {
    root: "MinervaTextField-root",
};
/**
 * ## Definition
 * The TextField component is a text input field that allows users to input text.
 *
 * ## Structure
 * - The TextField component is composed of a TextInputBase component.
 * - The DOM node of the TextField component is an input element.
 *
 * ## Behavior
 * - The onChange callback is triggered when the value of the input element changes. It receives the event object and the new value as arguments. Use the value argument for faster access to the new value.
 * - This component does not support the `multiline` prop. Use the MultilineTextField component for multiline text input.
 *
 * ## Technical Limitations
 * - As an extension of the TextInputBase, the TextField cannot be set to undefined as this represents an uncontrolled state. If you need to set the value to undefined, use an empty string instead.
 */
export const TextField = memo(forwardRef((props, ref) => {
    const { className, onChange, ...rest } = useDefaultProps({
        component: "TextField",
        props,
    });
    return (_jsx(TextInputBase, { as: "input", ref: ref, className: clsx([textFieldClasses.root, className]), onChange: (e) => {
            onChange?.(e, e.target.value);
        }, type: "text", ...rest }));
}));
//# sourceMappingURL=TextField.js.map